export let life = {
  mounted () {
    this.methods('computedRealWidth')
    this.methods('showOnloadMessage')
  }
}
export let event = {
  onerror (e) {
    this.methods('setFailImg', true)
    this.methods('setLoaddingImg', false)
  },
  srcUpdate () {
    this.methods('setFailImg', false)
    this.methods('setLoaddingImg', false)
    this.methods('showOnloadMessage')
  }
}
export let watch = {
  src () {
    this.methods('setFailImg', false)
    this.methods('setLoaddingImg', false)
    this.methods('showOnloadMessage')
  }
}
